export const NAME = 'consultationFiles';